import _t from 'i18n!nls/product-card';

export type MarketingTagCategory = 'job-ready' | 'job-skills' | 'bestseller' | 'top-ai-program' | 'trending-now';

export type MarketingStatusTag = {
  tag: string;
  tagName: string;
  category: MarketingTagCategory;
};

// Single master slug -> category map
// https://docs.google.com/spreadsheets/d/1AxnjBpMUYKKOasHHWH00r9uYv5Ef7O8lCBGJxDZERrg/edit?usp=sharing
const MARKETING_TAG_SLUG_MAP: Record<string, MarketingTagCategory> = {
  'aapc-medical-biller': 'job-ready',
  'adobe-content-creator': 'job-skills',
  'adobe-marketing-specialist': 'job-skills',
  'adp-payroll-specialist': 'bestseller',
  'ai-agents': 'top-ai-program',
  'ai-agents-for-leaders': 'top-ai-program',
  'ai-agents-python': 'top-ai-program',
  'ai-engineer': 'top-ai-program',
  'ai-essentials-google': 'top-ai-program',
  'ai-for-business-wharton': 'top-ai-program',
  'ai-for-everyone': 'top-ai-program',
  'ai-foundations-business-professionals': 'top-ai-program',
  'ai-foundations-for-everyone': 'top-ai-program',
  'ai-governance-iso42001-readiness-grc-audit-legal': 'top-ai-program',
  'ai-healthcare': 'top-ai-program',
  'ai-infrastructure-operations-fundamentals': 'top-ai-program',
  'ai-mastery': 'top-ai-program',
  'ai-product-management-duke': 'top-ai-program',
  'amazon-junior-software-developer': 'job-skills',
  'applied-artifical-intelligence-ibm-watson-ai': 'top-ai-program',
  'aws-generative-ai-developers': 'top-ai-program',
  'ba-liberal-studies-georgetown': 'job-ready',
  'bach-information-technology-illinois-tech': 'job-ready',
  'bachelor-of-science-computer-science-bits': 'job-ready',
  'bachelor-of-science-computer-science-london': 'job-ready',
  'bachelor-of-science-data-science-ai-iitguwahati': 'job-ready',
  'bachelor-of-science-general-business-unt': 'job-ready',
  'bachelor-of-science-psychology-jgu': 'job-ready',
  'bsc-business-administration-london': 'job-ready',
  'bsc-data-science-huddersfield': 'job-ready',
  'bsc-marketing-london': 'job-ready',
  'building-ai-agents-and-agentic-workflows': 'top-ai-program',
  'chatgpt-free-ai-tools-to-excel': 'top-ai-program',
  'data-analytics': 'job-skills',
  'data-engineering': 'job-skills',
  'data-science-foundations': 'bestseller',
  'decentralized-finance-duke': 'bestseller',
  'deep-learning': 'top-ai-program',
  'ec-council-information-security-analyst': 'job-ready',
  'emba-iitr': 'job-ready',
  'fast-prototyping-of-genai-apps-with-streamlit': 'job-skills',
  'fundamentals-of-machine-learning-and-artificial-intelligence': 'top-ai-program',
  'generative-ai-for-digital-marketing': 'top-ai-program',
  'generative-ai-for-everyone': 'top-ai-program',
  'generative-ai-for-growth-marketing': 'top-ai-program',
  'generative-ai-for-human-resources': 'top-ai-program',
  'generative-ai-for-leaders': 'top-ai-program',
  'generative-ai-for-project-managers': 'top-ai-program',
  'generative-ai-for-software-developers': 'top-ai-program',
  'generative-ai-for-software-development': 'top-ai-program',
  'generative-ai-software-engineering': 'top-ai-program',
  'generative-ai-strategic-leader': 'top-ai-program',
  'generative-ai-with-llms': 'top-ai-program',
  'google-agile-essentials': 'bestseller',
  'google-ai': 'top-ai-program',
  'google-cloud-data-analytics-certificate': 'job-skills',
  'google-people-management-essentials': 'bestseller',
  'hrci-human-resource-associate': 'job-ready',
  'ibm-ai-product-manager': 'top-ai-program',
  'ibm-business-analyst-professional-certificate': 'job-ready',
  'ibm-data-analyst': 'job-skills',
  'ibm-data-analyst-r-excel': 'bestseller',
  'ibm-data-engineer': 'job-skills',
  'ibm-digital-marketing-and-growth-hacking': 'job-skills',
  'ibm-full-stack-cloud-developer': 'job-skills',
  'ibm-generative-ai-engineering': 'top-ai-program',
  'ibm-isc2-cybersecurity-specialist': 'bestseller',
  'ibm-machine-learning': 'top-ai-program',
  'ibm-product-manager': 'job-ready',
  'ibm-product-owner': 'job-skills',
  'ibm-program-manager': 'job-skills',
  'ibm-rag-and-agentic-ai': 'top-ai-program',
  'ifp-computer-science-london': 'job-ready',
  imba: 'job-ready',
  imsa: 'job-ready',
  'indigenous-canada': 'bestseller',
  'introduction-data-science': 'job-skills',
  'introduction-to-generative-ai': 'top-ai-program',
  'intuit-bookkeeping': 'job-ready',
  'jhu-data-science': 'bestseller',
  'johns-hopkins-medical-office-manager': 'job-ready',
  'learn-korean': 'bestseller',
  'ma-international-relations-security-strategy-jgu': 'job-ready',
  'ma-public-policy-jgu': 'job-ready',
  'machine-learning': 'top-ai-program',
  'machine-learning-introduction': 'top-ai-program',
  'machine-learning-scikit-learn-pytorch-hugging-face': 'top-ai-program',
  'mas-data-science-illinois-tech': 'job-ready',
  'mas-engineering-berkeley': 'job-ready',
  'mas-information-technology-illinois-tech': 'job-ready',
  'master-computer-science-clemson': 'job-ready',
  'master-of-data-science-university-of-pittsburgh': 'job-ready',
  'master-of-science-data-science-boulder': 'job-ready',
  'mastering-claude-ai-prompting-apis-rag-and-mcp': 'top-ai-program',
  'masters-in-computer-data-science': 'job-ready',
  'mathematics-for-machine-learning-and-data-science': 'top-ai-program',
  'mathematics-machine-learning': 'top-ai-program',
  'mba-business-analytics-jgu': 'job-ready',
  'mba-illinois-tech': 'job-ready',
  'me-engineering-management-boulder': 'job-ready',
  'meng-computer-engineering-dartmouth': 'job-ready',
  'meta-back-end-developer': 'job-ready',
  'meta-data-analyst': 'job-skills',
  'meta-front-end-developer': 'job-ready',
  'meta-full-stack-developer': 'job-ready',
  'microsoft-365-copilot': 'top-ai-program',
  'microsoft-365-copilot-for-productivity': 'top-ai-program',
  'microsoft-ai-and-ml-engineering': 'top-ai-program',
  'microsoft-ai-product-manager': 'top-ai-program',
  'microsoft-cloud-support-associate': 'job-skills',
  'microsoft-copilot-your-everyday-ai-companion': 'top-ai-program',
  'microsoft-cybersecurity-analyst': 'job-skills',
  'microsoft-data-analysis-sql-excel-powerbi': 'job-skills',
  'microsoft-data-visualization': 'bestseller',
  'microsoft-full-stack-developer': 'job-ready',
  'microsoft-power-bi-data-analyst': 'job-skills',
  'microsoft-project-management': 'job-skills',
  'microsoft-sql-server': 'job-ready',
  'mlops-machine-learning-duke': 'top-ai-program',
  'ms-artificial-intelligence-boulder': 'job-ready',
  'ms-computer-science-ball-state': 'job-ready',
  'ms-computer-science-boulder': 'job-ready',
  'ms-data-analytics-engineering-northeastern': 'job-ready',
  'ms-data-science-ball-state': 'job-ready',
  'ms-engineering-management-northeastern': 'job-ready',
  'ms-management-illinois': 'job-ready',
  'msc-computer-science-heriot-watt': 'job-ready',
  'msc-cyber-security-london': 'job-ready',
  'msc-data-science-ul': 'job-ready',
  'msc-management-huddersfield': 'job-ready',
  'msee-boulder': 'job-ready',
  'natural-language-processing': 'top-ai-program',
  omie: 'job-ready',
  'prompt-engineering': 'top-ai-program',
  'prompting-essentials-google': 'top-ai-program',
  'pytorch-for-deep-learning': 'top-ai-program',
  'real-world-ai-for-everyone': 'top-ai-program',
  'retrieval-augmented-generation-rag': 'bestseller',
  'sales-development-representative': 'bestseller',
  'salesforce-sales-operations': 'bestseller',
  'software-engineering-fundamentals': 'bestseller',
  'unt-online-bachelor-completion': 'job-ready',
  'vibe-coding': 'top-ai-program',
  'wharton-success': 'bestseller',
  'ai-machinelearning-essentials': 'job-skills',
  'aws-cloud-technical-essentials': 'job-skills',
  'aws-generative-ai-applications': 'job-skills',
  'design-develop-and-deploy-multi-agent-systems-with-crewai': 'job-skills',
  'ai-prompting-for-everyone': 'top-ai-program',
  'gemini-for-developers': 'job-skills',
  'adobe-graphic-designer': 'job-skills',
  'agile-atlassian-jira': 'job-ready',
  'ai-financial-services-foundations-future-trends': 'top-ai-program',
  'ai-for-finance': 'top-ai-program',
  'applied-data-science': 'job-ready',
  'aws-cloud-practitioner-essentials': 'job-ready',
  'aws-cloud-solutions-architect': 'job-ready',
  'aws-cloud-support-associate': 'job-ready',
  'aws-cloud-technology-consultant': 'job-ready',
  'backend-javascript-developer': 'job-skills',
  'bi-analyst': 'bestseller',
  'biostatistics-public-health': 'job-skills',
  'business-financial-management': 'bestseller',
  'business-management-essentials': 'job-skills',
  'business-statistics-analysis': 'job-skills',
  'c-programming': 'job-skills',
  'cloud-engineering-gcp': 'job-ready',
  'creative-design-tools-adobe-photoshop-illustrator-acrobat': 'job-skills',
  'data-science-fundamentals-python-sql': 'bestseller',
  'data-skills-for-excel': 'job-skills',
  'devops-and-software-engineering': 'job-skills',
  'epic-games-game-design-professional-certificate': 'job-skills',
  'excel-data-analytics-visualization': 'job-skills',
  'facebook-marketing-analytics': 'job-skills',
  'finance-quantitative-modeling-analysts': 'job-skills',
  'financial-analyst-ai-excel-and-power-bi-skills': 'top-ai-program',
  financialengineering: 'job-skills',
  financialtechnology: 'job-skills',
  'generative-ai-data-analyst': 'top-ai-program',
  'generative-ai-for-ui-ux-design': 'top-ai-program',
  'gis-mapping-spatial-analysis': 'job-skills',
  'google-advanced-data-analytics': 'job-ready',
  'google-cloud-cybersecurity-certificate': 'job-skills',
  'google-data-analysis-with-python': 'bestseller',
  'health-informatics': 'job-skills',
  'ibm-backend-development': 'job-skills',
  'ibm-data-manager': 'bestseller',
  'ibm-data-science': 'job-skills',
  'ibm-deep-learning-with-pytorch-keras-tensorflow': 'top-ai-program',
  'ibm-intro-machine-learning': 'top-ai-program',
  'ibm-ios-android-mobile-app-developer-pc': 'job-skills',
  'ibm-it-project-manager': 'bestseller',
  'ibm-systems-analyst': 'job-skills',
  'ibm-ui-ux-designer': 'job-skills',
  'introduction-to-ai': 'top-ai-program',
  'it-fundamentals-cybersecurity': 'job-skills',
  'java-developer': 'job-skills',
  'keller-williams-real-estate-agent': 'job-ready',
  'mathematics-engineers': 'job-skills',
  'matlab-programming-engineers-scientists': 'job-skills',
  'meta-android-developer': 'job-ready',
  'microsoft-azure-ai-900-ai-fundamentals': 'top-ai-program',
  'microsoft-business-analyst': 'job-skills',
  'microsoft-data-architecture-for-modern-data-stacks': 'job-skills',
  'microsoft-it-support-specialist': 'job-skills',
  'microsoft-power-bi-and-power-platform-productivity': 'job-skills',
  'microsoft-python-developer': 'job-ready',
  'packt-cisco-ccna-200-301-the-complete-guide-to-getting-certified': 'job-ready',
  'packt-comptia-security-plus-certification-sy0-701-the-total-course': 'job-ready',
  'packt-docker-and-kubernetes-masterclass-from-beginner-to-advanced': 'job-skills',
  'pearson-certified-associate-in-project-management-capm-exam': 'job-ready',
  'pearson-pmp-certification': 'bestseller',
  'programming-python-java': 'bestseller',
  'sap-business-analyst': 'job-ready',
  'sap-technology-consultant': 'job-ready',
  'statistical-analysis-r-public-health': 'job-skills',
  'statistical-inference-for-data-science-applications': 'bestseller',
  'tableau-business-intelligence-analyst': 'bestseller',
  'unilever-digital-marketing-analyst': 'job-ready',
  'unlock-business-insights-with-microsoft-excel-and-power-bi': 'job-skills',
  'uol-business-and-marketing-strategies': 'job-skills',
  'ux-design': 'job-skills',
  'claude-ai-tools-for-beginners': 'top-ai-program',
  'generative-ai-engineering-with-llms': 'top-ai-program',
  'microsoft-generative-ai-engineering': 'top-ai-program',
  'ai-automation-engineer-n8n': 'top-ai-program',
  'preparing-for-google-cloud-machine-learning-engineer-professional-certificate': 'top-ai-program',
  'claude-code-in-action': 'top-ai-program',
  'microsoft-genai-for-data-analysis': 'top-ai-program',
  'machine-learning-specialization': 'top-ai-program',
  'ai-for-medicine': 'top-ai-program',
  'large-language-model-operations': 'top-ai-program',
  'gemini-for-google-workspace': 'top-ai-program',
  'microsoft-ai-agents': 'top-ai-program',
  'tensorflow-in-practice': 'top-ai-program',
  'reinforcement-learning': 'top-ai-program',
  'seo-mastery-from-fundamentals-to-genai-and-geo-strategies': 'top-ai-program',
  'self-driving-cars': 'top-ai-program',
  'organizational-strategy-generative-ai': 'top-ai-program',
  'generative-ai-for-executives-and-business-leaders': 'top-ai-program',
  'microsoft-ai-enhanced-data-analysis': 'top-ai-program',
  'packt-iapp-aigp-complete-training-ai-governance-mastery-c-qspza': 'top-ai-program',
  'inteligencia-artificial-ciencia-datos-negocios': 'top-ai-program',
  'snowflake-generative-ai': 'top-ai-program',
  'dlai-agentic-ai': 'top-ai-program',

  // https://docs.google.com/spreadsheets/d/1AxnjBpMUYKKOasHHWH00r9uYv5Ef7O8lCBGJxDZERrg/edit?gid=219402167#gid=219402167
  'google-project-management': 'trending-now',
  'google-cybersecurity': 'trending-now',
  'google-data-analytics': 'trending-now',
  'google-it-support': 'trending-now',
  'facebook-social-media-marketing': 'trending-now',
  'google-digital-marketing-ecommerce': 'trending-now',
  'google-ux-design': 'trending-now',
  'financial-modeling-and-analysis': 'trending-now',
  'technical-support-fundamentals': 'trending-now',
  excel: 'trending-now',
  'stanford-statistics': 'trending-now',
  'finance-accounting': 'trending-now',
  'wharton-business-foundations': 'trending-now',
  'project-management-foundations': 'trending-now',
  'learn-sql-basics-data-science': 'trending-now',
  'foundations-data': 'trending-now',
  'project-initiation-google': 'trending-now',
  positivepsychology: 'trending-now',
  'ask-questions-make-decisions': 'trending-now',
  'nasm-personal-fitness-trainer': 'trending-now',
  'python-3-programming': 'trending-now',
  'fullstack-development': 'trending-now',
  'master-microsoft-office-365-power-platform': 'trending-now',
  'foundations-of-cybersecurity': 'trending-now',
  'introduction-psychology': 'trending-now',
  sciwrite: 'trending-now',
  'meta-database-engineer': 'trending-now',
  'unilever-supply-chain-data-analyst': 'trending-now',
  'medical-neuroscience': 'trending-now',
  'google-business-intelligence': 'trending-now',
  'leading-teams': 'trending-now',
  'certificado-de-carrera-de-google-marketing-digital-e-e-commerce': 'trending-now',
  'financial-markets-global': 'trending-now',
  'os-power-user': 'trending-now',
  'food-and-health': 'trending-now',
  'learn-spanish': 'trending-now',
  'computer-networking': 'trending-now',
  'human-resource-management': 'trending-now',
  algorithms: 'trending-now',
  'google-it-automation': 'trending-now',
  'genomic-data-science': 'trending-now',
  negotiation: 'trending-now',
  'adp-compensation-benefits-analyst': 'trending-now',
  'negotiation-skills': 'trending-now',
  tesol: 'trending-now',
  'getting-started-with-google-workspace': 'trending-now',
  'authentic-communication-with-confidence-and-impact': 'trending-now',
  anatomy: 'trending-now',
  'microsoft-excel-learn-with-projects': 'trending-now',
  mafash: 'trending-now',
  thinklikeacfo: 'trending-now',
  'project-planning-google': 'trending-now',
  'futures-thinking': 'trending-now',
  brand: 'trending-now',
  'microsoft-introduction-to-c-plus-plus-programming': 'trending-now',
  'become-an-emt': 'trending-now',
  'tally-bookkeeper': 'trending-now',
  'investment-portolio-management': 'trending-now',
  'boost-your-leadership-impact': 'trending-now',
  'social-psychology': 'trending-now',
  'foundations-of-digital-marketing-and-e-commerce': 'trending-now',
  'ibm-project-manager': 'trending-now',
  'drug-hunting-discovery-and-development': 'trending-now',
  'wealth-management-specialization': 'trending-now',
  gis: 'trending-now',
  'microsoft-public-relations': 'trending-now',
  'discrete-mathematics': 'trending-now',
  'wharton-business-financial-modeling': 'trending-now',
  'six-sigma-fundamentals': 'trending-now',
  'microsoft-365-fundamentals': 'trending-now',
  filmmaking: 'trending-now',
  'digital-marketing': 'trending-now',
  'clinical-trials-operations': 'trending-now',
  'ibm-cybersecurity-analyst': 'trending-now',
  astro: 'trending-now',
  'introduction-to-cosmetic-science': 'trending-now',
  'workday-human-capital-management': 'trending-now',
  'procurement-sourcing': 'trending-now',
  'business-communication': 'trending-now',
  'data-science-foundations-r': 'trending-now',
  'good-with-words': 'trending-now',
  'introduction-to-data-analysis-using-python': 'trending-now',
  'cvshealth-call-center-customer-service': 'trending-now',
  'data-science-python': 'trending-now',
  'ibm-full-stack-javascript-developer': 'trending-now',
  'learnquest-certified-scrum-master': 'trending-now',
};

// tagName is kept as the pre-existing, stable analytics identifier for each category — it does
// not follow display-text casing changes, so tracking stays continuous with historical data.
const getMarketingTagContent = (category?: MarketingTagCategory): MarketingStatusTag | undefined => {
  switch (category) {
    case 'job-ready':
      return { tag: _t('Job ready'), tagName: 'Job Ready', category };
    case 'job-skills':
      return { tag: _t('Job skills'), tagName: 'Job Skills', category };
    case 'bestseller':
      return { tag: _t('Bestseller'), tagName: 'Bestseller', category };
    case 'top-ai-program':
      return { tag: _t('Top AI program'), tagName: 'Top AI Program', category };
    case 'trending-now':
      return { tag: _t('Trending right now'), tagName: 'Trending right now', category };
    default:
      return undefined;
  }
};

export const getMarketingStatusTagForSlug = (slug: string): MarketingStatusTag | undefined => {
  const category = MARKETING_TAG_SLUG_MAP[slug];
  return getMarketingTagContent(category);
};
